exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-dc0b57e8]:export{navy:#001d38;turquoiseBlue:#00adbc;white:#fff;black:#000;error:#b71c1c;cancel:#f75b4a;success:#7ed321}.booking-summary .summary-title[data-v-dc0b57e8]{font-family:Avenir-Heavy;font-size:16px}.booking-summary .v-overlay__scrim[data-v-dc0b57e8]{height:100vh;position:absolute;width:100vw}", ""]);

// exports
